import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { Auth } from '../../service/auth';

@Component({
	selector: 'app-teach-decimal-worksheet',
	templateUrl: './teach-decimal-worksheet.component.html',
	styleUrls: ['./teach-decimal-worksheet.component.css']
})
export class TeachDecimalWorksheetComponent implements OnInit {

	model: any = { 
		positiveCheck: false,
		shuffleQuiz: false
	};
	TimeList: Auth[];
	searchText;
	order: string = 'time';
	reverse: boolean = false;

	RegisterList: Auth[];
	keyCode: string;
	currentTeacherToken;
	quizName: string;
	teacherName: string;
	operatorType;
	operatorName: string;
	numberWhole: string;
	numberDecimal: string;
	numberWholeDividend: string;
	numberDecimalDividend: string;
	numberWholeDivisor: string;
	numberDecimalDivisor: string;
	numberQuestion: string;
	questions = [];
	counter;
	seconds;
	theCheckbox2 = false;

	key: string;

	constructor(private db: AngularFireDatabase,
		public router: Router,
		public authService: AuthService) { }

	ngOnInit() {
		this.model.operatorType = 0;
		for (let i = 5; i <= 100; i += 5) {
			this.questions.push(i);
		}
		this.tokenTeacherRegister();
		this.getTeacherRegister();
		this.MakeCode();
		this.getTime();
	}

	getTime() {
		const s = this.authService.getTimeList();
		s.snapshotChanges().subscribe(data => {
			this.TimeList = [];
			data.forEach(item => {
				const a = item.payload.toJSON();
				a['$key'] = item.key;
				this.TimeList.push(a as Auth);

			});
		});
	}

	MakeCode() {
		var length = 6;
		var result = '';
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@&/#-=';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		this.keyCode = result;
	}

	getTeacherRegister() {
		const s = this.authService.getRegisterTeacherList();
		s.snapshotChanges().subscribe(data => {
			this.RegisterList = [];
			data.forEach(item => {
				const a = item.payload.toJSON();
				a['$key'] = item.key;
				const b = item.payload.val().userId
				if (this.currentTeacherToken === b) {
					this.teacherName = item.payload.val().fullName;
					this.RegisterList.push(a as Auth);
				}
			});
		});
	}
	
	tokenTeacherRegister() {
		this.currentTeacherToken = localStorage.getItem('currentTeacherToken')
	}

	create() {
		var hms = this.model.counter;
		var a = hms.split(':');
		this.seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
		
		localStorage.setItem('numberWhole', this.model.numberWhole);
		localStorage.setItem('numberDecimal', this.model.numberDecimal);
		localStorage.setItem('numberWholeFirstFactor', this.model.numberWholeFirstFactor);
		localStorage.setItem('numberDecimalFirstFactor', this.model.numberDecimalFirstFactor);
		localStorage.setItem('numberWholeSecondFactor', this.model.numberWholeSecondFactor);
		localStorage.setItem('numberDecimalSecondFactor', this.model.numberDecimalSecondFactor);
		localStorage.setItem('numberWholeDividend', this.model.numberWholeDividend);
		localStorage.setItem('numberDecimalDividend', this.model.numberDecimalDividend);
		localStorage.setItem('numberWholeDivisor', this.model.numberWholeDivisor);
		localStorage.setItem('numberDecimalDivisor', this.model.numberDecimalDivisor)
		localStorage.setItem('numberQuestion', this.model.numberQuestion);
		localStorage.setItem('counter', this.seconds);
		const positiveCheckBox = this.model.positiveCheck.toString();
		localStorage.setItem('positiveCheckBox', positiveCheckBox);
		if (this.model.operatorType === 0) {
			this.operatorName = 'Addition-Decimal'
		}
		if (this.model.operatorType === 1) {
			this.operatorName = 'Subtraction-Decimal'
		}
		if (this.model.operatorType === 2) {
			this.operatorName = 'Multiplication-Decimal'
		}
		if (this.model.operatorType === 3) {
			this.operatorName = 'Division-Decimal'
		}
	}

	continue() {
		this.create();
		let keepGoing = true;
		this.db.database.ref('teacher_quiz_details')
			.once('value')
			.then((snapshot) => {
				snapshot.forEach(data => {
					const key = data.key;
					const a = data.val().code;
					if (keepGoing) {
						if (this.keyCode === a) {
							this.MakeCode();
							return keepGoing = false;
						}
					}
				});
				if (keepGoing === true) {
					this.db.list('teacher_quiz_details').push({
						userId: this.currentTeacherToken,
						testName: this.model.quizName,
						operator: this.operatorName,
						duration: this.seconds,
						totalQuiz: this.model.numberQuestion,
						status: 'Inactive',
						display: 'No',
						code: this.keyCode,
						shuffleQuiz: this.model.shuffleQuiz
					});

					this.sessionQuizDetails();
				}
			});
	}

	sessionQuizDetails() {
		this.db.database.ref('teacher_quiz_details')
			.once('value')
			.then((snapshot) => {
				snapshot.forEach(data => {
					const id = data.val().userId
					if (id === this.currentTeacherToken) {
						this.key = data.val().code;
					}
				});
				localStorage.setItem('quizDetailsToken', this.key)
				if (this.model.operatorType === 0) {
					this.router.navigate(['teacher-addition-decimal-worksheet'])
				}
				if (this.model.operatorType === 1) {
					this.router.navigate(['teacher-subtraction-decimal-worksheet'])
				}
				if (this.model.operatorType === 2) {
					this.router.navigate(['teacher-multiplication-decimal-worksheet'])
				}
				if (this.model.operatorType === 3) {
					this.router.navigate(['teacher-division-decimal-worksheet'])
				}
			});
	}
}

